<script>
    import eventOrder from './eventOrder.vue';
    export default {
        components: { eventOrder },
        emits: ['do-order'],
        data() {
            return {
                toggleSticky: false,
                toggleList: false,
            }
        },
        methods: {
            doOrder(availability,orderButton,eventStartDate,eventEndDate) {
                this.$emit('do-order', availability, orderButton, eventStartDate, eventEndDate);
            }
        },
        props: [
            'componentid',
            'orderlisttotalid',
            'orderlistextraid',
            'stickycollapsetxt',
            'moredatestxt',
            'activityid',
            'events',
            'otherticketstitle'
        ]
    }
</script>

<template>
    <div>

        <h5 v-if="events.length > 1 && otherticketstitle && activityid">{{otherticketstitle}}</h5>
    
        <template v-if="events.length === 1">
            <event-order :event="events[0]" @do-order="doOrder" :activityid="activityid"></event-order>
        </template>
        <template v-else-if="events.length < 5">
            
            <a :class="['order-list-toggle', 'button is-outlined', 'is-expanded', 'is-hidden', toggleSticky ? 'is-active' : '']" @click.prevent="toggleSticky = !toggleSticky">{{ stickycollapsetxt }} <i :class="['fa', toggleSticky ? 'fa-long-arrow-alt-up' : 'fa-long-arrow-alt-down']"></i></a>
            <div :id="orderlisttotalid" :class="['order-list-collapse-wrapper', toggleSticky ? 'is-active' : '']">
                <div class="order-list-total">
                <template v-for="(event, index) in events" :key="event.id">
                    <event-order :event="event" @do-order="doOrder" :activityid="activityid"></event-order>
                </template>
                </div>
            </div>
        </template>
        <template v-else>
            <a :class="['order-list-toggle', 'button is-outlined', 'is-expanded', 'is-hidden', , toggleSticky ? 'is-active' : '']" @click.prevent="toggleSticky = !toggleSticky">{{ stickycollapsetxt }} <i :class="['fa', toggleSticky ? 'fa-long-arrow-alt-up' : 'fa-long-arrow-alt-down']"></i></a>
            <div :id="orderlisttotalid" :class="['order-list-collapse-wrapper', toggleSticky ? 'is-active' : '']">
                <div class="order-list-total">
                    <template v-for="(event, index) in events.slice(0,3)" :key="event.id">
                        <event-order :event="event" @do-order="doOrder" :activityid="activityid"></event-order>
                    </template>
                    <a :class="['order-list-toggle', 'button', 'is-outlined', 'is-expanded', toggleList ? 'is-active' : '']" @click.prevent="toggleList = !toggleList">{{ moredatestxt }} <i :class="['fa', toggleList ? 'fa-long-arrow-alt-up' : 'fa-long-arrow-alt-down']"></i></a>
                    <div :id="orderlistextraid" :class="['order-list-collapse-wrapper', toggleList ? 'is-active' : '']">
                        <div class="order-list-extra">
                            <template v-for="(event, index) in events.slice(3,events.length)" :key="event.id">
                                <event-order :event="event" @do-order="doOrder" :activityid="activityid"></event-order>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>